import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';
import { useSelector } from 'react-redux';
import { Views } from 'src/components/Views';

import { Typography } from '@sravni/react-design-system';
import { ArrowLeft } from '@sravni/react-icons';

import { SravniNewsSharedEnumsMaterialType } from '../../../../__generated__/news/Api';
import { SPORT_RUBRICS } from '../../../../constants/news';
import { LIST, LIST_BY_RUBRICS } from '../../../../constants/routes';
import { getDate, getUpdateDate } from '../../../../helpers/news';
import { useDictionaries, useRubricType } from '../../../../hooks/news';
import { IGlobalState } from '../../../../reducers';
import { createLinkProps } from '../../../../utils/routing';
import { UpdateIcon } from '../../../Icons/Update';
import { IArticleProps } from '../Article';

import styles from './article-header.module.scss';
import { PartnerLabel } from './partnerLabel';

export interface IArticleInfoProps extends Pick<IArticleProps, 'material'> {
  isHighlight?: boolean;
}

export const ArticleInfo: React.FC<IArticleInfoProps> = ({ material, isHighlight = false }) => {
  const { rubrics } = useDictionaries();
  const { isWhitelabel } = useSelector((state: IGlobalState) => state.whitelabel);
  const rubricType = useRubricType();

  const isPartnerNews = rubricType === 'novosti-partnerov' || material.rubric === 'novosti-partnerov';

  const isSportRubric = SPORT_RUBRICS.includes(rubricType);

  let listLink = createLinkProps('list', LIST);
  if (isSportRubric) {
    listLink = createLinkProps('list', LIST_BY_RUBRICS, {
      rubric: 'sport',
    });
  }

  const renderPartnerLabel = () => {
    if (!isPartnerNews) return null;
    return <PartnerLabel organizationData={material.organizationData} />;
  };

  const renderRubric = () => {
    const rubric = rubrics?.find((el) => el.value === material.rubric);
    const isNotArticle = material.type !== SravniNewsSharedEnumsMaterialType.Article;

    if (isNotArticle || !rubric) return null;

    const rubricLink = createLinkProps('list', LIST_BY_RUBRICS, {
      rubric: rubric.alias,
    });

    return (
      <Typography.Text size={10} uppercase strong>
        <Link href={rubricLink.href} as={rubricLink.as}>
          <div className={classNames(styles.rubric)}>
            {rubric.iconUrl && (
              <img width={20} height={20} src={rubric.iconUrl} className={styles.rubricIcon} alt={'Иконка рубрики'} />
            )}
            <Typography.Link href={rubricLink.as} color={'dark'}>
              {rubric.name}
            </Typography.Link>
          </div>
        </Link>
      </Typography.Text>
    );
  };

  const updateDate = material.lastChangeDate && getUpdateDate(material.publishDate, material.lastChangeDate);

  return (
    <div className={styles.infoWrapper}>
      {!isHighlight && !isWhitelabel && (
        <Typography.Text size={14}>
          <Link href={listLink.href} as={listLink.as}>
            <Typography.Link className={styles.linkBack}>
              <ArrowLeft className={styles.linkBackIcon} />
              <span>{isSportRubric ? 'Важное в спорте сейчас' : 'Важное сейчас'}</span>
            </Typography.Link>
          </Link>
        </Typography.Text>
      )}
      <div className={styles.info}>
        <div className={classNames(styles.infoColumn, { [styles[`infoColumn--highlight`]]: isHighlight })}>
          <div className={styles.infoColumnInner}>
            <div className={styles.date}>
              <Typography.Text size={14}>{getDate(material.publishDate)}</Typography.Text>
            </div>
            {!isPartnerNews && material.visits > 0 && <Views className={styles.views}>{material.visits}</Views>}
          </div>
          {/*// TODO: remove color style from 'обновлено'*/}
          {!isHighlight && updateDate && (
            <div className={styles.update}>
              <UpdateIcon className={styles.updateIcon} />
              <Typography.Text size={14} className={'h-color-D30'}>
                Обновлено {updateDate}
              </Typography.Text>
            </div>
          )}
        </div>
        {renderRubric()}
        {renderPartnerLabel()}
      </div>
    </div>
  );
};
